import React, { SelectHTMLAttributes } from 'react';
import { Field, FieldProps } from 'formik';
import Select from 'react-select';

export interface FormikSelectProps
  extends SelectHTMLAttributes<HTMLSelectElement> {
  options?: { label: string; value: any }[];
  styles?: any;
  isMulti?: boolean;
  className?: string;
  change?: any;
}

const selectStyles = {
  control: (styles: any) => ({
    ...styles,
    backgroundColor: '#F5F5F5',
    padding: '6px',
    border: '2px solid #dadada',
    borderRadius: 5,
    width: '100%',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: '#bababa',
    fontWeight: 'bold',
  }),
};

const FormikSelect: React.FC<FormikSelectProps> = ({
  name,
  options,
  placeholder,
  styles,
  change,
  className,
  isMulti,
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <Select
          className={className}
          placeholder={placeholder}
          options={options}
          value={field.value}
          onChange={(item) => { form.setFieldValue(field.name, item); if (change) change(item) }}
          styles={{ ...selectStyles, ...styles }}
          isMulti={isMulti}
        />
      )}
    </Field>
  );
};

export default FormikSelect;
